import procedimentoRepository from './procedimentoRepository'
import exportacaoRepository from './exportacaoRepository'
import relatorioInconsistenciaRepository from './relatorioInconsistenciaRepository'

export default baseUrl => {
    baseUrl = `${baseUrl}/apac`

    return {
        procedimento: procedimentoRepository(baseUrl),
        exportacao: exportacaoRepository(baseUrl),
        relatorioInconsistencia: relatorioInconsistenciaRepository(baseUrl),
    }
}
